import { MockCards, MockQuestions } from '../../../../utils/mock-data/public/programs-page';

export const programPageDataFetch = async () => MockCards;
export const questionDataFetch = async () => MockQuestions;
